
                                            // for header border radius

function initParallaxToggle() {
    const mycheckbox = document.getElementById('enableParallax');
    const myheader = document.querySelector('.header-wrapper.color-scheme-1.gradient.header-wrapper--border-bottom');
    const bodayOverflow = document.querySelector('body.gradient');
    function toggleBorderRadius() {
        if (mycheckbox.checked) {
            myheader.style.borderRadius = '10px 10px 0 0';
            bodayOverflow.style.overflow = 'hidden';
        } else {
            myheader.style.borderRadius = '';
            bodayOverflow.style.overflow = '';
        }
    }

    function delayedToggleBorderRadius() {
        setTimeout(toggleBorderRadius, 250);
    }

    mycheckbox.addEventListener('change', delayedToggleBorderRadius);

    delayedToggleBorderRadius();
}

initParallaxToggle();

                                            // for header border radius

// function toggleBorderRadiusOnClick() {
//     const menuItems = document.querySelectorAll('.header__menu-item.list-menu__item.link.focus-inset');
//     const header = document.querySelector('.header-wrapper.color-scheme-1.gradient.header-wrapper--border-bottom');

//     let isBorderRadiusApplied = false;

//     function toggleBorderRadius() {
//         if (isBorderRadiusApplied) {
//             header.style.borderRadius = '10px';
//         } else {
//             header.style.borderRadius = '10px 10px 0 0';
//         }
//         isBorderRadiusApplied = !isBorderRadiusApplied;
//     }

//     menuItems.forEach(menuItem => {
//         menuItem.addEventListener('click', toggleBorderRadius);
//     });
// }

// toggleBorderRadiusOnClick();


                                        // for On hover show dropdown and border Radius

  
let itemss = document.querySelector(".header__inline-menu").querySelectorAll("details");
const headerWrapper = document.querySelector(".header-wrapper.color-scheme-1.gradient.header-wrapper--border-bottom");
const header = document.querySelector('header'); // The main header element

itemss.forEach(item => {
  item.addEventListener("mouseover", () => {
    // Close all other open details elements
    itemss.forEach(i => {
      if (i !== item) {
        i.removeAttribute("open");
        i.querySelector("summary").setAttribute("aria-expanded", "false");
      }
    });

    // Open the current hovered details and update aria-expanded
    item.setAttribute("open", true);
    item.querySelector("summary").setAttribute("aria-expanded", "true");

    // Apply border-radius when dropdown is opened
    if (headerWrapper) {
      headerWrapper.style.borderRadius = "10px 10px 0 0";
    }
  });

  // Listen for mouseleave on the entire header, not just the dropdown
  header.addEventListener("mouseleave", () => {
    // Remove 'open' attribute and update aria-expanded for the hovered item
    item.removeAttribute("open");
    item.querySelector("summary").setAttribute("aria-expanded", "false");

    // Reset border-radius after dropdown is closed
    if (headerWrapper) {
      headerWrapper.style.borderRadius = ""; // Remove inline style and revert to CSS
    }
  });
});

                                        // for On hover show dropdown and border Radius


                                                            // for built a pair button mobile

document.querySelector('.header__icon--menu').addEventListener('click', function() {
    const headingLink = document.querySelector('.header__heading-link.link.link--text.focus-inset');
    const cartIcon = document.querySelector('#cart-icon-bubble');
    const buildPair = document.querySelector('.built-pair');
    const theheader = document.querySelector('.header');
    const thenavbar = document.querySelector('.utility-bar__grid');
  
    // Toggle visibility of headingLink and cartIcon
    [headingLink, cartIcon].forEach(element => {
        if (element) {
            element.style.display = (element.style.display === 'none') ? 'flex' : 'none';
        }
    });

    // Check if both headingLink and cartIcon are hidden
    if (headingLink.style.display === 'none' && cartIcon.style.display === 'none') {
        if (buildPair) {
            buildPair.style.display = 'flex';
            buildPair.style.setProperty('display', 'block');
            buildPair.style.width = 'fit-content';
            buildPair.style.minWidth = '146px';
            buildPair.style.margin = '14px 0 0';
            theheader.style.position = 'relative';
            theheader.style.zindex = '1';
            thenavbar.style.display = 'none';
        }
    } else {
        if (buildPair) {
            buildPair.style.display = 'none';
            buildPair.style.margin = '';
            theheader.style.position = '';
            theheader.style.zindex = '';
            thenavbar.style.display = '';
        }
    }
});



// for when input checked the p1 will close


document.getElementById('enableParallax').addEventListener('change', function() {
  const detailsElements = document.querySelectorAll('details[open]');
  const summaryElements = document.querySelectorAll('details summary');

  if (this.checked) {
    detailsElements.forEach(details => {
      details.removeAttribute('open');
      // Set aria-expanded to false for the associated summary
      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    });
  } else {
    // Optionally, you can handle the case when the checkbox is unchecked
    detailsElements.forEach(details => {
      const summary = details.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', 'true');
      }
    });
  }
});


// for when input checked the p1 will close





